import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { useAuth } from "../contexts/AuthContext";

function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("📝 Soumission du formulaire de connexion");
    setError("");

    try {
      console.log("🔄 Tentative de connexion avec:", username);
      const success = await login(username, password);
      if (success) {
        console.log("✅ Connexion réussie, redirection vers /");
        navigate("/");
      } else {
        console.log("❌ Échec de la connexion");
        setError("Identifiants invalides");
      }
    } catch (error) {
      console.error("❌ Erreur lors de la connexion:", error);
      setError("Erreur lors de la connexion");
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Typography component="h1" variant="h5">
            Connexion Robot2Kiko
          </Typography>
          <Box
            component="form"
            onSubmit={(e) => {
              console.log("📝 Formulaire soumis");
              handleSubmit(e);
            }}
            sx={{ mt: 1 }}
          >
            <TextField
              margin="normal"
              required
              fullWidth
              id="username"
              label="Nom d'utilisateur"
              name="username"
              autoComplete="username"
              autoFocus
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Mot de passe"
              type="password"
              id="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            {error && (
              <Typography color="error" sx={{ mt: 2 }}>
                {error}
              </Typography>
            )}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              onClick={() => console.log("🔘 Bouton de connexion cliqué")}
            >
              Se connecter
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
}

export default Login;
